import { Box, Tab, Tabs, Button } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { TabPanel } from "./TabPanel/TabPanel";
import { TabSortNotes } from "./TabPanel/TabSortNotes";
import { useState, useEffect } from "react";
import moment from "moment";

export const SortFilter = ({token, idDocument, nameDocument, notaSeleccionada, notasSeleccionadas}) => {
    const [value, setValue] = useState(0);
    const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
    
    useEffect(() => {
    }, [notaSeleccionada, notasSeleccionadas]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleOpenPreview = () => {
        const url = `/preview/${idDocument}?name=${encodeURIComponent(nameDocument || "Documento")}&date=${selectedDate}`;
        window.open(url, '_blank');
    };

    return (
        <>
        <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", justifyContent: "space-between", alignItems: "center", pr: 2 }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="Tabs"
          >
            <Tab label="Secciones" />
          </Tabs>
          <Button 
            variant="outlined" 
            size="small" 
            startIcon={<DescriptionIcon />}
            onClick={handleOpenPreview}
            sx={{ textTransform: 'none', borderRadius: 2 }}
          >
            Ver Documento
          </Button>
        </Box>
        <TabPanel value={value} index={0}>
          <TabSortNotes 
            token={token} 
            idDocument={idDocument} 
            notaSeleccionada={notaSeleccionada} 
            notasSeleccionadas={notasSeleccionadas}
            selectedDate={selectedDate}
            onDateChange={setSelectedDate}
          />
        </TabPanel>
      </>
    );  
}